/* Mayfair & Finch - Swatch Image Switcher */

function initSwatches() {
  var swatches = document.querySelectorAll('.mf-color-swatch');

  swatches.forEach(function(swatch) {
    if (swatch.getAttribute('data-swatch-init')) return;
    swatch.setAttribute('data-swatch-init', '1');

    var card = swatch.closest('.grid-product__content') || swatch.closest('.grid__item');
    if (!card) return;

    function getImg() {
      var gridItem = swatch.closest('.grid__item');
      if (!gridItem) return null;
      // Zoek de img binnen de product link, niet binnen de swatches
      var link = gridItem.querySelector('a.grid-product__link');
      if (link) {
        return link.querySelector('img') || null;
      }
      return gridItem.querySelector('.grid-product__image') ||
             gridItem.querySelector('img');
    }

    function setImgSrc(img, src) {
      img.src = src;
      img.setAttribute('data-src', src);
      img.removeAttribute('srcset');
      img.removeAttribute('data-srcset');
      img.classList.remove('lazyload');
      img.classList.add('lazyloaded');
    }

    swatch.addEventListener('mouseenter', function() {
      var variantImage = swatch.getAttribute('data-variant-image');
      if (!variantImage) return;
      var img = getImg();
      if (!img) return;
      if (!img.getAttribute('data-mf-original-src')) {
        img.setAttribute('data-mf-original-src', img.src || img.getAttribute('data-src'));
      }
      setImgSrc(img, variantImage);
      // Preload buurswatches zodat klik direct werkt
      var siblings = card.querySelectorAll('.mf-color-swatch');
      siblings.forEach(function(s) {
        var src = s.getAttribute('data-variant-image');
        if (src && !s.dataset.preloaded) {
          s.dataset.preloaded = '1';
          new Image().src = src;
        }
      });
    });

    swatch.addEventListener('mouseleave', function() {
      var img = getImg();
      if (!img) return;
      var activeSwatch = card.querySelector('.mf-color-swatch--active');
      if (activeSwatch) {
        var activeImage = activeSwatch.getAttribute('data-variant-image');
        if (activeImage) { setImgSrc(img, activeImage); return; }
      }
      var original = img.getAttribute('data-mf-original-src');
      if (original) setImgSrc(img, original);
    });

    swatch.addEventListener('click', function(e) {
      e.preventDefault();
      card.querySelectorAll('.mf-color-swatch').forEach(function(s) {
        s.classList.remove('mf-color-swatch--active');
      });
      swatch.classList.add('mf-color-swatch--active');
      var variantImage = swatch.getAttribute('data-variant-image');
      if (variantImage) {
        var img = getImg();
        if (img) setImgSrc(img, variantImage);
      }
      // Update de product link URL naar de geselecteerde variant
      var href = swatch.getAttribute('href');
      if (href) {
        var link = card.querySelector('a.grid-product__link');
        if (link) link.setAttribute('href', href);
      }
    });
  });
}

/* Collectie swatch slider */

function initSwatchSliders() {
  document.querySelectorAll('.mf-swatches-slider').forEach(function(slider) {
    if (slider.dataset.sliderInit) return;

    var track = slider.querySelector('.mf-swatches-track');
    var btnPrev = slider.querySelector('.mf-sl-prev');
    var btnNext = slider.querySelector('.mf-sl-next');
    if (!track) return;

    var swatches = track.querySelectorAll('.mf-color-swatch');
    var total = swatches.length;
    var current = 0;

    function getSwatchSize() {
      var el = swatches[0];
      if (!el) return 37;
      return el.offsetWidth + 3;
    }

    function getVisible() {
      var size = getSwatchSize();
      if (size === 0) return 4;
      // Slider breedte zonder pijltjes
      var sliderW = slider.offsetWidth;
      return Math.max(1, Math.floor((sliderW - 10) / size));
    }

    function update() {
      var visible = getVisible();
      var size = getSwatchSize();
      var maxCurrent = Math.max(0, total - visible);
      current = Math.min(current, maxCurrent);
      current = Math.max(0, current);

      track.style.transform = 'translateX(-' + (current * size) + 'px)';

      if (btnPrev) btnPrev.classList.toggle('visible', current > 0);
      if (btnNext) btnNext.classList.toggle('visible', current < maxCurrent);
    }

    function setupButtons() {
      slider.dataset.sliderInit = '1';
      if (btnPrev) {
        btnPrev.addEventListener('click', function(e) {
          e.preventDefault();
          current = Math.max(0, current - 1);
          update();
        });
      }
      if (btnNext) {
        btnNext.addEventListener('click', function(e) {
          e.preventDefault();
          // Fix 2: max zodat laatste swatch volledig zichtbaar is
          var maxCurrent = Math.max(0, total - getVisible());
          current = Math.min(maxCurrent, current + 1);
          update();
        });
      }
      update();
    }

    // Wacht op breedte als nog niet beschikbaar
    if (slider.offsetWidth === 0) {
      setTimeout(function() {
        if (getVisible() < total) setupButtons();
      }, 300);
      return;
    }

    if (getVisible() < total) setupButtons();
  });
}

function preloadSwatchImages() {
  document.querySelectorAll('.mf-color-swatch').forEach(function(swatch) {
    var src = swatch.getAttribute('data-variant-image');
    if (src) {
      var img = new Image();
      img.src = src;
    }
  });
}

function initAll() {
  initSwatches();
  initSwatchSliders();
}

document.addEventListener('DOMContentLoaded', initAll);
document.addEventListener('shopify:section:load', initAll);
setTimeout(initSwatchSliders, 500);
setTimeout(initSwatchSliders, 1500);

// Vang featured collection secties op als ze later in de DOM verschijnen
if (window.MutationObserver) {
  new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      m.addedNodes.forEach(function(n) {
        if (n.nodeType === 1 && n.querySelector && n.querySelector('.mf-swatches-slider')) {
          setTimeout(function() { initSwatches(); initSwatchSliders(); }, 100);
        }
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
}
